import React from 'react';
import { Box, Heading, Paragraph } from 'components';
import { formatDate } from 'utils/formatStrings';

interface ProductQuoteInfoProps {
  process: string;
  material: string;
  quantity: number;
  validUntil: string;
  supplier?: string;
}

export const ProductQuoteInfo = ({
  process,
  material,
  quantity,
  validUntil,
  supplier,
}: ProductQuoteInfoProps) => {
  return (
    <Box
      px={5}
      pb={3}
      sx={{ display: 'flex', justifyContent: 'space-between' }}
    >
      <Box mr={2}>
        <Heading level='5' size='small'>
          Fabrication Process
        </Heading>
        <Paragraph>{process}</Paragraph>
      </Box>
      <Box mr={2}>
        <Heading level='5' size='small'>
          Material
        </Heading>
        <Paragraph>{material}</Paragraph>
      </Box>
      <Box mr={2}>
        <Heading level='5' size='small'>
          Quantity
        </Heading>
        <Paragraph>{quantity}</Paragraph>
      </Box>
      <Box mr={2}>
        <Heading level='5' size='small'>
          Valid Until
        </Heading>
        <Paragraph>{formatDate(validUntil)}</Paragraph>
      </Box>
      {supplier && (
        <Box mr={2}>
          <Heading level='5' size='small'>
            Produced in
          </Heading>
          <Paragraph>{supplier}</Paragraph>
        </Box>
      )}
    </Box>
  );
};
